import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Clipboard from '@react-native-clipboard/clipboard'

import { View, Linking, TouchableOpacity, Platform } from 'react-native'

import { VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components'

import Card from '../../Components/Card'

import styles from './Embassies.Styles'


const Embassies = ({ title, data, theme }) => {
  const [copyState, setCopyState] = useState('roaming_embassies_copy')

  useEffect(() => {
    copyState === ('roaming_embassies_copied') &&
      setTimeout(() => {
        setCopyState('roaming_embassies_copy')
      }, 1000)

  }, [copyState])

  return (
    <>
      {/* Embassy Card*/}
      <View>
        <VFText i18nKey={title} style={styles.boldTitle} />
      </View>

      <Card style={styles.cardStyle} theme={theme}>
        {/* Title */}
        <VFText i18nKey={data?.title} style={styles.boldSubtitle} />

        {/* Location */}
        {data?.location &&
          <View style={[styles.row, styles.borderBottom, styles.bottomPadding]}>
            <TouchableOpacity onPress={() => {
              Platform.OS === 'android' ?
                Linking.openURL(`http://maps.google.com/maps?daddr=${data?.location}`) :
                Linking.openURL(`http://maps.apple.com/maps?daddr=${data?.location}`)
            }} style={styles.locationButton}>
              <VFText
                i18nKey={data?.location}
                style={styles.underlinedText(theme)}
              />
            </TouchableOpacity>
            <VFButton
              title={copyState}
              style={styles.copyButton}
              type="secondary"
              onPress={() => {
                Clipboard.setString(data?.location)
                setCopyState('roaming_embassies_copied')
              }}
            />
          </View>
        }

        {/* Embassy title */}
        {data?.openingHours &&
          <>
            <VFText i18nKey={'roaming_embassies_working_hours'} style={styles.boldSubtitle} />
            {data?.openingHours?.map(item => (
              <VFText i18nKey={item} style={styles.graySubtitle} />
            ))}
          </>
        }

        <View style={styles.contactContainer}>
          {data?.email &&
            <>
              <VFText i18nKey={'Email'} style={styles.boldSubtitle} />
              <View style={styles.emailContainer}>
                <TouchableOpacity
                  onPress={() => {
                    Linking.openURL(`mailto:${data?.email}`)
                  }}
                  style={styles.emailButton}
                >
                  <VFText i18nKey={data?.email} style={styles.emailFormat(theme)} />
                </TouchableOpacity>
              </View>
            </>
          }
          {data?.phone &&
            <>
              <VFText i18nKey={'roaming_embassies_phone_number'} style={[styles.boldSubtitle, { marginTop: 28 }]} />
              <VFText i18nKey={data?.phone} style={styles.phoneNumber} />
            </>
          }
        </View>

        <View style={styles.row}>
          {data?.phone &&
            <VFButton
              title={'roaming_embassies_call'}
              style={styles.buttonStyle}
              type="secondary"
              onPress={() => {
                Linking.openURL(`tel:${data?.phone}`)
              }}
            />
          }
          {data?.website &&
            <VFButton
              title={'roaming_embassies_website'}
              style={styles.buttonStyle}
              type="secondary"
              onPress={() => {
                Linking.openURL(data?.website)
              }}
            />
          }
        </View>
      </Card>
    </>
  )
}

Embassies.defaultProps = {}

Embassies.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  theme: PropTypes.object
}

export default Embassies
